module.exports = __webpack_public_path__ + "img/LTS_KPMG_.3f72c0a0.gif";